// Centralized API URL configuration
// This ensures consistent API URL handling across the entire app

/**
 * Get the API base URL
 * Priority:
 * 1. REACT_APP_BACKEND_URL environment variable (if set)
 * 2. Current window origin (auto-detects for both dev preview and production)
 */
export const getApiUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  // Fallback to current origin - works for any deployment
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }
  // Server-side fallback
  return '/api';
};

export const API_URL = getApiUrl();

/**
 * Get the base backend URL (without /api suffix)
 */
export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

export const BACKEND_URL = getBackendUrl();
